<template>
  <div class="dashboard-tab-root">
    <div class="dashboard-base-bg">
      <div class="dashboard-sec-bg">
        <div class="dashboard-mybalance">
          <div class="total-income" @click="handleJumpInviteDetail">
            <div class="total-income-left">
              <span class="total-income-label">{{ $t('lang.BaseCommon.k081') }}</span>
            </div>
            <div class="total-income-right">
              <span class="total-income-value">{{ info.agentSumBean }}</span>
              <img class="icon-arrow-r ar-arrow" src="@/assets/packageAssets/common/arrow11.webp" alt="" />
            </div>
          </div>

          <div class="balance-section">
            <div class="balance-header">
              <span class="balance-title">{{ $t('lang.BaseCommon.k102') }}</span>
              <div class="withdraw-btn" @click.stop="handleWithdraw">{{ $t('lang.BaseCommon.k096') }}</div>
            </div>
            <div class="balance-values">
              <div class="balance-beans">
                <img class="beans-icon" :src="getMatchImg('beans')" alt="" />
                <span class="beans-count">{{ info.walletBean }}</span>
              </div>
              <div class="balance-price">
                ≈
                <span class="currency-code">{{ info.currencyCode }}</span>
                {{ numberTransformK(info.currencyAmount / 100, info.locationCode) }}
              </div>
            </div>
          </div>
        </div>

        <div class="week-switch-tab">
          <div class="week-switch-inner">
            <div class="week-tab" :class="{ 'active-tab': weekTabIndex === 0 }" @click="handleWeekTab(0)">
              {{ $t('lang.BaseCommon.k034') }}
            </div>
            <div class="week-tab" :class="{ 'active-tab': weekTabIndex === 1 }" @click="handleWeekTab(1)">
              {{ $t('lang.BaseCommon.k042') }}
            </div>
          </div>
        </div>

        <div class="week-income-summary">
          <div class="week-income-value">
            <img class="beans-icon" :src="getMatchImg('beans')" alt="" />
            <span class="income-number">{{ thousandthDigit(weekTotalIncome) }}</span>
          </div>
          <div class="week-income-label">
            <template v-if="showWeekIncomeEstimatedLabel">
              <span class="label-text">{{ $t('lang.Invite.k103') }}</span>
              <CTipPopover v-model="showIncomeTip" placement="bottom">
                <template #trigger>
                  <img class="info-icon" src="@/assets/packageAssets/views/P2_Page/Invite/default/tip1.webp" alt="" />
                </template>
                {{ $t('lang.Invite.k110') }}
              </CTipPopover>
            </template>
            <span v-else class="label-text">{{ $t('lang.BaseCommon.k032') }}</span>
          </div>
        </div>

        <div class="income-detail-list">
          <div class="income-card income-card-row">
            <span class="card-tag">{{ $t('lang.Invite.k104') }}</span>
            <div class="card-row-main">
              <div class="card-row-left" @click="toRules('inviteBonus')">
                <span class="card-title">{{ $t('lang.Invite.k065') }}</span>
                <img class="info-icon" src="@/assets/packageAssets/views/P2_Page/Invite/default/tip1.webp" alt="" />
              </div>
              <div class="card-row-right">
                <img class="beans-icon" :src="getMatchImg('beans')" alt="" />
                <span class="card-value">{{ thousandthDigit(inviteBonusBeans) }}</span>
              </div>
            </div>
          </div>

          <div class="income-card income-card-commission">
            <span v-if="showCommissionSettleTag" class="card-tag">{{ $t('lang.Invite.k104') }}</span>
            <div class="commission-body">
              <div class="commission-header" @click="toRules()">
                <div class="card-row-left">
                  <span class="card-title">{{ $t('lang.Invite.k067') }}</span>
                  <img class="info-icon" src="@/assets/packageAssets/views/P2_Page/Invite/default/tip1.webp" alt="" />
                </div>
              </div>
              <div class="commission-main">
                <div class="commission-value">
                  <img class="beans-icon" :src="getMatchImg('beans')" alt="" />
                  <span>{{ thousandthDigit(dashboardWeekInfo.weekAgentCommissionBeans || 0) }}</span>
                </div>
                <div class="percent-bar">
                  <PercentBar
                    :percentCount="dashboardWeekInfo.weekHostEarningBeans"
                    :earnTypeList="dashboardWeekInfo.commissionLevelList"
                  ></PercentBar>
                </div>
              </div>
            </div>
            <div class="commission-divider"></div>
            <div class="commission-footer" @click="toViolationDetails">
              <span class="footer-title">{{ $t('lang.Invite.k024') }}</span>
              <div class="card-row-right">
                <img class="beans-icon" :src="getMatchImg('beans')" alt="" />
                <span class="card-value">{{ thousandthDigit(dashboardWeekInfo.weekHostDeductionBeans || 0) }}</span>
                <img class="arrow-icon ar-arrow" src="@/assets/packageAssets/common/arrow11.webp" alt="" />
              </div>
            </div>
          </div>
          <!-- Sub-agent Event Bonus -->
          <div class="income-card income-card-event">
            <span v-if="showEventSettleTag" class="card-tag">{{ $t('lang.Invite.k104') }}</span>
            <div class="card-row-main">
              <div class="card-row-left card-row-left-col">
                <div class="card-title-row">
                  <span class="card-title">{{ $t('lang.Invite.k071') }}</span>
                  <img
                    class="info-icon"
                    src="@/assets/packageAssets/views/P2_Page/Invite/default/tip1.webp"
                    alt=""
                    @click.stop="toRules('subAgentEventBonus')"
                  />
                </div>
                <MyPLabel class="card-subtitle" :str="$t('lang.Invite.k106')" :numsOption="eventBonusSubtitleNums" />
              </div>
              <div class="card-row-right">
                <img class="beans-icon" :src="getMatchImg('beans')" alt="" />
                <span class="card-value">{{ thousandthDigit(dashboardWeekInfo.subAgentActInviteBeanReward || 0) }}</span>
              </div>
            </div>
          </div>

          <!-- Sub-agent Commission -->
          <div class="income-card income-card-row income-card-sub">
            <span v-if="showSubSettleTag" class="card-tag">{{ $t('lang.Invite.k104') }}</span>
            <div class="card-row-main">
              <div class="card-row-left card-row-left-col">
                <div class="card-title-row">
                  <span class="card-title">{{ $t('lang.Invite.k098') }}</span>
                  <img
                    class="info-icon"
                    src="@/assets/packageAssets/views/P2_Page/Invite/default/tip1.webp"
                    alt=""
                    @click.stop="toRules('subAgentCommission')"
                  />
                </div>
                <p class="card-subtitle">
                  <span class="subtitle-label">{{ $t('lang.Invite.k105') }}</span>
                  <span class="subtitle-value">{{ dashboardWeekInfo.subAgentCommissionRate || 0 }}%</span>
                </p>
              </div>
              <div class="card-row-right">
                <img class="beans-icon" :src="getMatchImg('beans')" alt="" />
                <span class="card-value">{{ thousandthDigit(dashboardWeekInfo.subAgentCommission || 0) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { numberTransformK } from '@/utils/common'
import { apiFetchDashboardLast } from '@/api/invite'
import { apiFetchMyInvite } from '@/api/imee'

import PercentBar from './PercentBar.vue'

export default {
  components: { PercentBar },
  props: {
    info: {
      type: Object,
      default: () => {
        return undefined
      },
    },
  },
  data() {
    return {
      weekTabIndex: 0,
      showIncomeTip: false,
      lastWeekInfo: null,
      inviteBonusBeans: 0,
    }
  },
  computed: {
    dashboardWeekInfo() {
      if (this.weekTabIndex === 0) {
        return this.info || {}
      }
      return this.lastWeekInfo || {}
    },
    // 上周总收益状态：三个结算字段全部为已到账(1)，才视为已到账
    lastWeekIncomeSettled() {
      const data = this.lastWeekInfo || {}
      return [data.agentCommissionSettleState, data.subAgentActSettleState, data.subAgentCommissionSettleState].every((state) =>
        this.isSettleStateSettled(state)
      )
    },
    // 上周未到账显示 Estimated Income + tips，已到账显示 Income
    showWeekIncomeEstimatedLabel() {
      if (this.weekTabIndex === 0) {
        return true
      }
      return !this.lastWeekIncomeSettled
    },
    showCommissionSettleTag() {
      return this.weekTabIndex === 1 && this.isSettleStateSettled(this.dashboardWeekInfo.agentCommissionSettleState)
    },
    showEventSettleTag() {
      return this.weekTabIndex === 1 && this.isSettleStateSettled(this.dashboardWeekInfo.subAgentActSettleState)
    },
    showSubSettleTag() {
      return this.weekTabIndex === 1 && this.isSettleStateSettled(this.dashboardWeekInfo.subAgentCommissionSettleState)
    },
    weekTotalIncome() {
      const data = this.dashboardWeekInfo
      return (
        (data.subAgentCommission || 0) + (data.subAgentActInviteBeanReward || 0) + (data.weekAgentCommissionBeans || 0) + (this.inviteBonusBeans || 0)
      )
    },
    eventBonusSubtitleNums() {
      const data = this.dashboardWeekInfo
      return [
        { value: this.thousandthDigit(data.nextLevelGap || 0), class: 'subtitle-highlight' },
        { value: this.thousandthDigit(data.nextLevelReward || 0), class: 'subtitle-highlight' },
      ]
    },
  },
  watch: {
    info: {
      handler() {
        this.lastWeekInfo = null
        if (this.weekTabIndex === 0) {
          this.fetchInviteBonus(1)
        } else if (this.weekTabIndex === 1) {
          this.fetchLastWeekInfo()
        }
      },
      deep: true,
    },
  },
  created() {
    this.fetchInviteBonus(1)
  },
  methods: {
    numberTransformK: numberTransformK,
    handleWithdraw() {
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'entrance', AValue: 'withdraw' })
      } catch (err) {
        console.log('try catch', err)
      }
      this.$router.push({
        path: '/withdrawal',
        query: { fromPage: 'invite', walletType: 1 },
      })
    },
    handleJumpInviteDetail() {
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'entrance', AValue: 'details' })
      } catch (err) {
        console.log('try catch', err)
      }
      this.$router.push({ path: '/invite-history' })
    },
    toRules(location = 'commission') {
      const target = typeof location === 'string' ? location : 'commission'
      this.$router.push({ path: '/invite-rules', query: { location: target } })
    },
    toViolationDetails() {
      this.$router.push({ path: '/violation-details', query: { week: this.weekTabIndex } })
    },
    handleCopyId(item) {
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'button', AValue: 'copy' })
      } catch (err) {
        console.log('try catch', err)
      }
      this.handleCopy(item.presentId, this.$t('lang.BaseCommon.k071'))
    },
    isSettleStateSettled(state) {
      return Number(state) === 1
    },
    handleWeekTab(index) {
      this.weekTabIndex = index
      this.showIncomeTip = false
      if (index === 0) {
        this.fetchInviteBonus(1)
        return
      }
      if (!this.lastWeekInfo) {
        this.fetchLastWeekInfo()
      }
      this.fetchInviteBonus(2)
    },
    fetchInviteBonus(timeType) {
      apiFetchMyInvite({ timeType, offset: 0, limit: 1 }).then((res) => {
        if (res && !res.error && timeType === (this.weekTabIndex === 0 ? 1 : 2)) {
          this.inviteBonusBeans = res.inviteBonusBeans || 0
        }
      })
    },
    fetchLastWeekInfo() {
      apiFetchDashboardLast().then((res) => {
        this.lastWeekInfo = res || null
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.dashboard-tab-root {
  .dashboard-base-bg {
    width: 343px;
    margin: auto;
    background: #d0c6b6;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    .dashboard-sec-bg {
      background: #fefefe;
      border-radius: 16px;
      border-start-start-radius: 0;
      .dashboard-mybalance {
        width: 343px;
        margin: auto;
        padding: 16px;
        background: #ffffff;
        border-radius: 16px;
        overflow: hidden;

        .total-income {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-bottom: 12px;
          border-bottom: 1px solid #ededed;

          .total-income-left {
            display: flex;
            align-items: center;

            .total-income-label {
              font-family: var(--string-font);
              font-weight: var(--fw-400);
              font-size: var(--fs-16);
              line-height: var(--lh-label-18);
              color: #333333;
            }
          }

          .total-income-right {
            display: flex;
            align-items: center;

            .total-income-value {
              font-family: var(--string-font);
              font-weight: var(--fw-400);
              font-size: var(--fs-16);
              line-height: var(--lh-label-18);
              color: #333333;
            }

            .icon-arrow-r {
              width: 16px;
              height: 16px;
              margin-left: 4px;
            }
          }

          .info-icon {
            width: 16px;
            height: 16px;
          }
        }

        .balance-section {
          padding-top: 12px;

          .balance-header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .balance-title {
              font-family: var(--string-font);
              font-weight: var(--fw-700);
              font-size: var(--fs-20);
              line-height: var(--lh-title-28);
              color: #333333;
            }

            .withdraw-btn {
              flex-shrink: 0;
              padding: 8px 16px;
              background: #f5e1c0;
              border-radius: 24px;
              font-family: var(--string-font);
              font-weight: var(--fw-400);
              font-size: var(--fs-14);
              line-height: var(--lh-label-18);
              color: #925e0d;
              text-align: center;
            }
          }

          .balance-values {
            margin-top: 8px;

            .balance-beans {
              display: flex;
              align-items: center;

              .beans-icon {
                width: 20px;
                height: 20px;
              }

              .beans-count {
                margin-left: 4px;
                font-family: var(--string-font);
                font-weight: var(--fw-400);
                font-size: var(--fs-16);
                line-height: var(--lh-label-18);
                color: #333333;
              }
            }

            .balance-price {
              margin-top: 4px;
              font-family: 'Inter-Regular', var(--string-font);
              font-weight: var(--fw-700);
              font-size: var(--fs-32);
              line-height: var(--lh-headline-36);
              color: #333333;

              .currency-code {
                font-family: 'Inter-Regular', var(--string-font);
              }
            }
          }
        }
      }

      .week-switch-tab {
        width: 300px;
        margin: 0 auto;
        padding: 8px 0 16px;

        .week-switch-inner {
          display: flex;
          align-items: center;
          background: #eeeae4;
          border-radius: 36px;

          .week-tab {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px 12px;
            border-radius: 24px;
            border: 4px solid transparent;
            box-sizing: border-box;
            font-family: var(--string-font);
            font-weight: var(--fw-400);
            font-size: var(--fs-12);
            line-height: var(--lh-title-20);
            color: #a9a092;
            text-align: center;
            white-space: nowrap;

            &.active-tab {
              color: #ffffff;
              border-color: #eeeae4;
              background: linear-gradient(180deg, #f6e0b3 0%, #c6a175 42.79%, #86592e 100%);
            }
          }
        }
      }

      .week-income-summary {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 12px 16px;
        text-align: center;

        .week-income-value {
          display: flex;
          align-items: center;
          justify-content: center;

          .beans-icon {
            width: 20px;
            height: 20px;
          }

          .income-number {
            margin-left: 2px;
            font-family: 'Inter-Regular', var(--number-font);
            font-weight: var(--fw-600);
            font-size: var(--fs-20);
            line-height: var(--lh-title-28);
            color: #333333;
          }
        }

        .week-income-label {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 8px;

          :deep(.c-tip-popover) {
            margin-left: 2px;
          }

          .label-text {
            font-family: var(--string-font);
            font-weight: var(--fw-400);
            font-size: var(--fs-14);
            line-height: var(--lh-title-20);
            color: #b2b2b2;
          }

          .info-icon {
            width: 16px;
            height: 16px;
            cursor: pointer;
          }
        }
      }

      .income-detail-list {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 0 12px 16px;
        box-sizing: border-box;

        .income-card {
          position: relative;
          width: 100%;
          background: #f9f8f6;
          border-radius: 10px;
          box-sizing: border-box;

          &:not(:first-child) {
            margin-top: 8px;
          }

          .card-tag {
            position: absolute;
            top: 0;
            inset-inline-start: 0;
            z-index: 1;
            display: inline-block;
            max-width: fit-content;
            white-space: nowrap;
            padding: 1.5px 8px 0.5px;
            background: #fff6c4;
            border-inline-end: 0.5px solid #ffffff;
            border-bottom: 0.5px solid #ffffff;
            border-start-start-radius: 8px;
            border-end-end-radius: 8px;
            font-family: var(--string-font);
            font-weight: var(--fw-400);
            font-size: var(--fs-10);
            line-height: var(--lh-label-14);
            color: #925e0d;
            box-sizing: border-box;
          }

          .card-row-main {
            padding: 16px 12px;

            .card-row-left {
              display: flex;
              flex: 1;
              align-items: center;
              min-width: 0;

              .card-title {
                font-family: var(--string-font);
                font-weight: var(--fw-400);
                font-size: var(--fs-14);
                line-height: var(--lh-title-20);
                color: #333333;
                white-space: nowrap;
              }

              .info-icon {
                flex-shrink: 0;
                width: 16px;
                height: 16px;
                margin-left: 2px;
              }
            }

            .card-row-left-col {
              flex-direction: column;
              align-items: flex-start;

              .card-title-row {
                display: flex;
                align-items: center;
                min-height: 20px;

                .card-title {
                  font-family: var(--string-font);
                  font-weight: var(--fw-400);
                  font-size: var(--fs-14);
                  line-height: var(--lh-title-20);
                  color: #333333;
                  white-space: nowrap;
                }

                .info-icon {
                  flex-shrink: 0;
                  width: 16px;
                  height: 16px;
                  margin-left: 2px;
                }
              }

              .card-subtitle {
                margin: 0;
                margin-left: 2px;
                font-family: var(--string-font);
                font-weight: var(--fw-400);
                font-size: var(--fs-12);
                line-height: var(--lh-label-16);
                color: #333333;

                .subtitle-label {
                  color: #b2b2b2;
                }

                .subtitle-value {
                  color: #666666;
                }
              }
            }

            .card-row-right {
              margin-top: 8px;
              display: flex;
              flex-shrink: 0;
              align-items: center;

              .beans-icon {
                width: 16px;
                height: 16px;
              }

              .card-value {
                font-family: var(--number-font);
                font-weight: var(--fw-500);
                font-size: var(--fs-16);
                line-height: var(--lh-body-20);
                color: #333333;
                white-space: nowrap;
                padding: 0 2px;
              }

              .arrow-icon {
                width: 16px;
                height: 16px;
                margin-left: 2px;
              }
            }
          }

          &.income-card-row,
          &.income-card-event {
            .card-row-main {
              padding: 24px 12px 16px;
            }
          }

          &.income-card-event {
            background: linear-gradient(102.03deg, #ffcf88 0%, #f0e6c4 100%);

            .card-row-main {
              .card-row-left-col {
                .card-subtitle {
                  color: rgba(51, 51, 51, 0.5);

                  :deep(.subtitle-highlight) {
                    color: rgba(51, 51, 51, 0.8);
                    font-style: normal;
                  }
                }
              }
            }
          }

          &.income-card-sub {
            .card-row-main {
              .card-row-left-col {
                max-width: 207px;
              }
            }
          }

          &.income-card-commission {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 16px 12px;

            .commission-body {
              display: flex;
              flex-direction: column;
              width: 100%;

              .commission-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                padding: 6px 0;

                .card-row-left {
                  display: flex;
                  flex: 1;
                  align-items: center;
                  min-width: 0;

                  .card-title {
                    font-family: var(--string-font);
                    font-weight: var(--fw-400);
                    font-size: var(--fs-14);
                    line-height: var(--lh-title-20);
                    color: #333333;
                    white-space: nowrap;
                  }

                  .info-icon {
                    flex-shrink: 0;
                    width: 16px;
                    height: 16px;
                    margin-left: 2px;
                  }
                }
              }

              .commission-main {
                display: flex;
                flex-direction: column;
                width: 100%;
                margin-top: 12px;

                .commission-value {
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;

                  .beans-icon {
                    width: 16px;
                    height: 16px;
                  }

                  span {
                    margin-left: 3px;
                    font-family: 'Inter-Regular', var(--number-font);
                    font-weight: var(--fw-500);
                    font-size: var(--fs-16);
                    line-height: var(--lh-title-20);
                    color: #333333;
                  }
                }

                .percent-bar {
                  width: 100%;
                  margin-top: 8px;
                  padding: 0 0 8px;
                }
              }
            }

            .commission-divider {
              width: 100%;
              height: 1px;
              margin-top: 8px;
              background: #ededed;
            }

            .commission-footer {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              margin-top: 8px;
              padding: 6px 0;

              .footer-title {
                flex: 1;
                min-width: 0;
                font-family: var(--string-font);
                font-weight: var(--fw-400);
                font-size: var(--fs-12);
                line-height: var(--lh-title-20);
                color: #333333;
              }

              .card-row-right {
                display: flex;
                flex-shrink: 0;
                align-items: center;
                margin-left: 16px;

                .beans-icon {
                  width: 12px;
                  height: 12px;
                  margin: 0 2px;
                }

                .card-value {
                  font-family: var(--string-font);
                  font-size: var(--fs-10);
                  line-height: var(--lh-title-20);
                  color: #333333;
                }

                .arrow-icon {
                  width: 16px;
                  height: 16px;
                  margin-left: 2px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .dashboard-tab-root {
    direction: rtl;

    .dashboard-base-bg {
      .dashboard-sec-bg {
        .dashboard-mybalance {
          .total-income {
            .total-income-right {
              .icon-arrow-r {
                margin-left: 4px;
                margin-right: 0;
              }
            }
          }

          .balance-section {
            .balance-values {
              .balance-beans {
                .beans-count {
                  margin-left: 0;
                  margin-right: 4px;
                }
              }
            }
          }
        }

        .week-switch-tab {
          .week-switch-inner {
            direction: rtl;
          }
        }

        .week-income-summary {
          .week-income-value {
            .income-number {
              margin-left: 0;
              margin-right: 2px;
            }
          }

          .week-income-label {
            :deep(.c-tip-popover) {
              margin-left: 0;
              margin-right: 2px;
            }
          }
        }

        .income-detail-list {
          .income-card {
            .card-row-main {
              .card-row-left {
                .card-title {
                  text-align: right;
                }

                .info-icon {
                  margin-left: 0;
                  margin-right: 2px;
                }
              }

              .card-row-left-col {
                .card-title-row {
                  .info-icon {
                    margin-left: 0;
                    margin-right: 2px;
                  }
                }

                .card-subtitle {
                  margin-left: 0;
                  margin-right: 2px;
                  text-align: right;
                }
              }

              .card-row-right {
                margin-left: unset;
                margin-right: 8px;

                .arrow-icon {
                  margin-left: 0;
                  margin-right: 2px;
                }
              }
            }

            &.income-card-event,
            &.income-card-sub {
              .card-row-main {
                .card-row-right {
                  margin-right: 0;
                }
              }
            }

            &.income-card-commission {
              .commission-body {
                .commission-header {
                  .card-row-left {
                    .card-title {
                      text-align: right;
                    }

                    .info-icon {
                      margin-left: 0;
                      margin-right: 2px;
                    }
                  }
                }

                .commission-main {
                  .commission-value {
                    span {
                      margin-left: 3px;
                      margin-right: 0;
                    }
                  }
                }
              }

              .commission-footer {
                .footer-title {
                  text-align: right;
                }

                .card-row-right {
                  margin-left: 0;
                  margin-right: 16px;

                  .arrow-icon {
                    margin-left: 0;
                    margin-right: 2px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
